import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { OrgId } from 'app/common/types/id'
import { api } from 'app/api'

import {
  GET_BUILDINGS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/schools/buildings/get'

import { orgsFilterSelection } from './orgsFilter'

type Buildings = Array<ItemType>

class BuildingsFilterDataBox extends DataBox<Buildings> {}

export const defaultBuildings: Buildings = []
export const buildingsFilter = createDataBox(
  'buildingsFilter',
  defaultBuildings,
  BuildingsFilterDataBox,
)

export const defaultBuildingsDataReceiver = async (orgsSelection?: Array<string>) => {
  const orgIds = orgsSelection || orgsFilterSelection.getData() || [null]
  const orgId = orgIds[0]
  if (!orgId) return []

  const res = await api.request(GET_BUILDINGS, {
    error: 'Не удалось получить данные корпусов',
    params: {
      orgId: orgId as OrgId,
    },
    convertions: {
      convertParams,
      convertResult,
    },
  })
  return res || []
}

buildingsFilter.addDataReceiver(defaultBuildingsDataReceiver)

export const defaultBuildingsSelection: Array<string> = []
export const buildingsFilterSelection = createDataBoxDefault<Array<string>>(
  'buildingsFilterSelection',
  defaultBuildingsSelection,
)
